"use client";
import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  Label,
} from "recharts";

const rawData = [
  { year: 1990, Kenya: 4.61, World: 6.04, "Sub-Saharan Africa": 5.72 },
  { year: 1995, Kenya: 4.85, World: 5.79, "Sub-Saharan Africa": 6.11 },
  { year: 2000, Kenya: 5.07, World: 5.24, "Sub-Saharan Africa": 5.68 },
  { year: 2005, Kenya: 4.92, World: 5.01, "Sub-Saharan Africa": 5.04 },
  { year: 2010, Kenya: 4.67, World: 4.71, "Sub-Saharan Africa": 4.42 },
  { year: 2015, Kenya: 4.75, World: 4.21, "Sub-Saharan Africa": 3.97 },
  { year: 2020, Kenya: 4.42, World: 3.93, "Sub-Saharan Africa": 4.08 },
  { year: 2021, Kenya: 4.23, World: 3.91, "Sub-Saharan Africa": 4.11 },
  { year: 2022, Kenya: 4.12, World: 3.81, "Sub-Saharan Africa": 3.96 },
  { year: 2023, Kenya: 4.01, World: 3.76, "Sub-Saharan Africa": 3.89 },
];

export default function EnergyIntensityChart({ isActive }: { isActive: boolean }) {
  const [data, setData] = useState<any[]>([]);
  const [animationKey, setAnimationKey] = useState(0);

  useEffect(() => {
    if (isActive) {
      setTimeout(() => {
        setData(rawData);
        setAnimationKey((prev) => prev + 1);
      }, 200);
    } else {
      setData([]);
    }
  }, [isActive]);

  return (
    <div className="w-full h-full flex justify-center items-center bg-[#f9f9f9] p-4 font-sans relative">
      <div className="w-full max-w-[900px] h-[450px] relative mt-5 flex flex-col items-center">
        <h2 className="text-center font-bold mb-6 text-[20px] text-[#003350]">
          Energy Intensity
        </h2>
        <div className="w-full flex-1 min-h-[300px]">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={data}
              key={animationKey}
              margin={{ top: 10, right: 10, left: 15, bottom: 25 }}
            >
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
              <XAxis
                dataKey="year"
                ticks={[1990, 1995, 2000, 2005, 2010, 2015, 2020, 2021, 2022, 2023]}
                tick={{ fill: "#4b5563", fontSize: 11 }}
                axisLine={{ stroke: "#9ca3af" }}
                tickLine={true}
              >
                <Label
                  value="Year"
                  position="insideBottom"
                  offset={-15}
                  style={{ textAnchor: "middle", fill: "#4b5563", fontWeight: 500, fontSize: 13 }}
                />
              </XAxis>
              <YAxis
                domain={[3.5, 6.5]}
                ticks={[3.5, 4.0, 4.5, 5.0, 5.5, 6.0, 6.5]}
                tickFormatter={(val) => val.toFixed(2)}
                tick={{ fill: "#4b5563", fontSize: 11 }}
                axisLine={{ stroke: "#9ca3af" }}
                tickLine={true}
              >
                <Label
                  value="Energy intensity (MJ per 2021 PPP)"
                  angle={-90}
                  position="insideLeft"
                  offset={-5}
                  style={{ textAnchor: "middle", fill: "#4b5563", fontWeight: 500, fontSize: 13 }}
                />
              </YAxis>
              <Tooltip
                formatter={(value: any) => [Number(value).toFixed(2), ""]}
                labelFormatter={(label) => `Year: ${label}`}
              />
              <Legend
                verticalAlign="bottom"
                align="center"
                iconType="line"
                iconSize={20}
                wrapperStyle={{
                  paddingTop: 15,
                  fontSize: 12,
                  fontWeight: 500,
                  color: "#4b5563",
                }}
              />
              <Line
                type="linear"
                dataKey="Kenya"
                stroke="#5b9bd5"
                strokeWidth={3}
                dot={false}
                activeDot={{ r: 6 }}
                isAnimationActive={true}
              />
              <Line
                type="linear"
                dataKey="World"
                stroke="#ed7d31"
                strokeWidth={3}
                dot={false}
                activeDot={{ r: 6 }}
                isAnimationActive={true}
              />
              <Line
                type="linear"
                dataKey="Sub-Saharan Africa"
                stroke="#a5a5a5"
                strokeWidth={3}
                dot={false}
                activeDot={{ r: 6 }}
                isAnimationActive={true}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
